import type { AgentRunContextSnapshot } from "./types";

const TOKENS_PER_HISTORY_MSG = 150;
const TOKENS_PER_MEMORY = 100;
const TOKENS_EVENT_CONTEXT = 200;

export const estimateContextTokens = (snapshot: AgentRunContextSnapshot) =>
  Math.round(
    snapshot.rollingSummaryChars / 4
    + snapshot.conversationHistoryCount * TOKENS_PER_HISTORY_MSG
    + snapshot.turbopufferMemoryCount * TOKENS_PER_MEMORY
    + (snapshot.hasEventContext ? TOKENS_EVENT_CONTEXT : 0),
  );

export const formatContextSizeMessage = (snapshot: AgentRunContextSnapshot) => {
  const est = estimateContextTokens(snapshot);
  const parts = [
    `${snapshot.conversationHistoryCount} msgs`,
    snapshot.rollingSummary
      ? `${snapshot.rollingSummaryChars.toLocaleString()} summary chars`
      : "no summary",
    `${snapshot.turbopufferMemoryCount} memories`,
    snapshot.hasEventContext ? "event ctx" : "no event ctx",
  ];

  const guest = snapshot.guestDetail ? ` · ${snapshot.guestDetail}` : "";

  return `Context ~${est.toLocaleString()} tok in — ${parts.join(", ")}${guest}`;
};
